// static/table_engine_src/core/lifecycle.js

/**
 * Render-finished notification scheduling + DOM event.
 * Installs on ctx:
 *   - ctx.setSuppressRenderNotify(bool)
 *   - ctx.scheduleNotifyRendered()
 *   - ctx._setLifecycleApi(api)   (engine.js calls this once api is created)
 */
export function installLifecycle(ctx, { onRender } = {}) {
  if (!ctx || typeof ctx !== "object") return;

  let _suppress = false;
  let _pending = false;
  let _api = null;

  function notifyRendered() {
    const api = _api;
    if (!api || !api.table) return;
    const tbody = ctx.tbody;
    if (!tbody || !tbody.querySelector) return;

    if (typeof onRender === "function") {
      try {
        onRender(api);
      } catch (e) {
        console.warn("[TableEngine] opts.onRender failed:", e);
      }
    }

    try {
      api.table.dispatchEvent(new CustomEvent("te:render", { detail: { engine: api } }));
    } catch {
      // best-effort
    }
  }

  function scheduleNotifyRendered() {
    if (_suppress) return;
    if (_pending) return;
    _pending = true;

    const run = () => {
      _pending = false;
      notifyRendered();
    };

    if (typeof queueMicrotask === "function") queueMicrotask(run);
    else Promise.resolve().then(run);
  }

  ctx.setSuppressRenderNotify = (b) => {
    _suppress = !!b;
  };
  ctx.scheduleNotifyRendered = scheduleNotifyRendered;

  // engine.js calls this after it creates the public api object
  ctx._setLifecycleApi = (api) => {
    _api = api || null;
  };
}